import React, { Component } from 'react';
import AbstractChart from './AbstractChart';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import worldCloud from 'highcharts/modules/wordcloud';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import moment from 'moment';
import { chartColorCode } from './colorCodes';
import {
  CHART_BACKGROUND_COLOUR,
  DEFAULT_CHART_HEIGHT,
  DEFAULT_CHART_WIDTH,
  FILTER_DATE_RANGE_FORMAT,
  DEFAULT_TITLE_STYLE,
  DEFAULT_NO_DATA_OPTIONS,
  DEFAULT_ZOOM_TYPE,
  DEFAULT_PAN_KEY,
  SERIES_KEY
} from './constants/HighchartsConstants';

worldCloud(Highcharts);

class WordCloud extends AbstractChart {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      source: [],
      topicId: null,
      mapDataFromProps: [],
      filterDateRange: {
        fromDate: moment().format(FILTER_DATE_RANGE_FORMAT),
        toDate: moment().format(FILTER_DATE_RANGE_FORMAT),
      },
      mapOptions: {
        chart: {
          zoomType: DEFAULT_ZOOM_TYPE,
          panKey: DEFAULT_PAN_KEY,
          panning: true,
          pinchType: DEFAULT_ZOOM_TYPE,
          type: 'wordcloud',
          backgroundColor: CHART_BACKGROUND_COLOUR,
          marginTop: 25,
          marginLeft: 15,
          marginRight: 15,
          marginBottom: 15,
          width: DEFAULT_CHART_WIDTH,
          height: DEFAULT_CHART_HEIGHT,
        },
        title: {...DEFAULT_TITLE_STYLE},
        noData: {...DEFAULT_NO_DATA_OPTIONS},
        credits: {
          enabled: false,
        },
      },
    };
  }

  reRenderChartOnChange = props => {
    const { retrieveSelectedChartData } = this.props.actions;
    this.setState(
      {
        filterDateRange: props.dateRangeFilterValue,
        source: props.source,
        topicId: props.selectedTopicId,
      },
      () => {
        retrieveSelectedChartData({
          chartId: this.props.chartId.replace('chart', ''),
          dateFilterValue: this.state.filterDateRange,
          topicId: this.state.topicId,
          source: this.state.source,
        });
      },
    );
  };

  componentDidMount() {
    this.reRenderChartOnChange(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { chartId, selectedTopicId } = this.props;
    if (
      JSON.stringify(newProps.WordCloud[chartId]) !== JSON.stringify(this.state.mapDataFromProps)
    ) {
      const { title } = this.props;
      const chartData = newProps.WordCloud[chartId];

      let { mapOptions } = this.state;
      const updatedChartData = chartData['word'].map((word, index) => {
        return {
          name: word.replace('_', ' '),
          weight: chartData['freq'][index],
          color: chartColorCode[title.split(' ')[1].toLowerCase()],
        };
      });
      mapOptions.title.text = title;
      mapOptions[SERIES_KEY] = [
        {
          data: updatedChartData,
          name: 'Frequency',
          style: {
            fontFamily: 'Arial',
          },
        },
      ];
      this.setState({
        chartData: mapOptions[SERIES_KEY],
        mapOptions: mapOptions,
        mapDataFromProps: newProps.WordCloud[chartId],
        source: newProps.source,
        topicId: selectedTopicId,
      });
    }

    if (this._shouldReRenderChartBasedOnNewProps(newProps)) {
      this.reRenderChartOnChange(newProps);
    }
  }

  render() {
    const { mapOptions, mapDataFromProps } = this.state;
    const deepCopyOfMapOptions = JSON.parse(JSON.stringify(mapOptions));
    return (
      <React.Fragment>
        {Object.keys(mapDataFromProps).length > 0 ? (
          <HighchartsReact
            highcharts={Highcharts}
            options={deepCopyOfMapOptions}
            allowChartUpdate={true}
            immutable={false}
            updateArgs={[true, true, true]}
          />
        ) : (
          <HighchartsReact highcharts={Highcharts} options={deepCopyOfMapOptions} />
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    WordCloud: state.charts,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WordCloud);



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/WordCloud.js